class CollectionBannerSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.collection-banner-chroxel__slide'));
    this.dots = Array.from(this.querySelectorAll('.collection-banner-chroxel__dot'));
    this.prevButton = this.querySelector('.collection-banner-chroxel__arrow--prev');
    this.nextButton = this.querySelector('.collection-banner-chroxel__arrow--next');
    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = (parseFloat(this.dataset.speed) || 6) * 1000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        this.restart();
      });
    });

    this.prevButton?.addEventListener('click', () => {
      this.goTo(this.current - 1);
      this.restart();
    });

    this.nextButton?.addEventListener('click', () => {
      this.goTo(this.current + 1);
      this.restart();
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  goTo(index) {
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current]?.setAttribute('aria-selected', 'false');
    this.dots[this.current]?.classList.remove('is-active');

    this.current = (index + this.slides.length) % this.slides.length;

    this.slides[this.current].classList.add('is-active');
    this.dots[this.current]?.setAttribute('aria-selected', 'true');
    this.dots[this.current]?.classList.add('is-active');
  }

  start() {
    if (!this.autoplay) return;
    this.stop();
    this.timer = setInterval(() => this.goTo(this.current + 1), this.speed);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}

customElements.define('collection-banner-slider', CollectionBannerSlider);
